export default "__VITE_ASSET__sIolfMLz__"